module.exports = __webpack_public_path__ + "img/factura.bd119460.svg";